module.exports = __webpack_public_path__ + "static/media/cstore-services-flyer.83e16ad7.jpg";